export default __webpack_public_path__ + "static/media/crown.9c4d9262.svg";